import { useCardName } from 'hooks/useCardName'

export default function CardName({ cardBrand }: { cardBrand: string }) {
  const cardName = useCardName(cardBrand)

  return <>{cardName}</>
}
